import React from 'react';
import ImageUploader from '../../../common/components/ImageUploader/ImageUploader';

export default class ImageUploaderContainer extends React.PureComponent {
  state = {
    value: this.props.value,
  };

  static get defaultProps() {
    return {
      // aspectRatio: 4 / 3,
      crop: true,
      cropRequired: true,
    };
  }

  onImageChange = link => {
    this.setState({ value: link });
  };

  render() {
    const inputValue = this.state.value || '';
    const imageProps = {
      crop: this.props.crop,
      aspectRatio: parseFloat(this.props.aspectRatio),
      cropRequired: this.props.cropRequired,
      label: this.props.label,
    };
    return (
      <React.Fragment>
        <input type="text" name={this.props.name} value={inputValue} className="hidden" readOnly />
        <ImageUploader {...imageProps} onChange={this.onImageChange} value={this.state.value} />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/containers/InputControls/ImageUploader.js